module.exports = __webpack_public_path__ + "static/media/pardakht.dcd0cb49.jpg";